import type { IIAMConfig } from '../../types/iam-config'
import { apiClient } from '../api/apiClient'
import { logger } from '../../utils/logger'

export const iamConfigService = {
  /**
   * Fetch IAM configuration from the backend
   * Uses ISTIO_MESH channel automatically via apiClient
   */
  async fetchIAMConfig(): Promise<IIAMConfig> {
    try {
      logger.log('Fetching IAM configuration...')
      const response = await apiClient.get<IIAMConfig>('/iam-config/v1/configs')
      logger.log('IAM configuration fetched successfully, version:', response.version)
      return response
    } catch (error) {
      logger.error('Failed to fetch IAM configuration:', error)
      throw new Error('Failed to fetch IAM configuration. Please contact the platform team.')
    }
  }
}
